import i18n from "sveltekit-i18n";
import type { Config } from "sveltekit-i18n";

import en from "./en";
import fr from "./fr";
import lang from "./lang.json";

const config: Config = {
	translations: {
		en: {
			...en,
			lang
		},
		fr: {
			...fr,
			lang
		}
	}
};

export const { t, locale, locales, loading, loadTranslations } = new i18n(config);
